import React from 'react';

import {
  Flex,
  Box,
  FormControl,
  FormLabel,
  Input,
  Checkbox,
  Stack,
  Link,
  Button,
  Heading,
  Text,
  useColorModeValue,
} from '@chakra-ui/react';

import FormBackgroundImage from '../assets/images/Form-Background-Image.jpg';

function Login() {
  return (
    <div className="login-page page">
      <Flex
        minH={'80vh'}
        align={'center'}
        justify={'center'}
        className={'fade-in-1'}
      >
        <Stack spacing={8} mx={'auto'} maxW={'lg'} py={12} px={6}>
          <Stack align={'center'}>
            <Heading
              fontSize={'4xl'}
              color={'brand.black'}
            >
              Log in to your account
            </Heading>
            <Text fontSize={'lg'} color={'gray.600'}>
              and be the change you want to see
            </Text>
          </Stack>
          <Box
            rounded={'lg'}
            bg={useColorModeValue('white', 'gray.700')}
            boxShadow={'lg'}
            p={8}>
            <Stack spacing={4}>
              <FormControl id="email">
                <FormLabel>Email address</FormLabel>
                <Input type="email" />
              </FormControl>
              <FormControl id="password">
                <FormLabel>Password</FormLabel>
                <Input type="password" />
              </FormControl>
              <Stack spacing={10}>
                <Stack
                  direction={{ base: 'column', sm: 'row' }}
                  align={'start'}
                  justify={'space-between'}>
                  <Checkbox
                    iconColor='brand.main'
                    colorScheme='white'
                  >
                    Remember me
                  </Checkbox>
                  <Link color={'brand.main'}>Forgot password?</Link>
                </Stack>
                <Button
                  as={'a'}
                  href={'/'}
                  bg={'brand.main'}
                  color={'white'}
                  _hover={{
                    bg: 'brand.dark',
                  }}>
                  Log in
                </Button>
              </Stack>
            </Stack>
          </Box>
        </Stack>
        <img
          className={'background-image low-opacity'}
          src={FormBackgroundImage}
          alt='Diverse team working hard'
        />
      </Flex>
    </div>
  );
}

export default Login;
